// extracted by mini-css-extract-plugin
export default {"diseaseIcon":"DiseaseIcon_diseaseIcon__yxP2Z","diseaseTitle":"DiseaseIcon_diseaseTitle__k3XIM","diseaseHead":"DiseaseIcon_diseaseHead__oNLnp"};